import { createClient, SupabaseClient } from '@supabase/supabase-js'

// =====================================================================
// Growthly CRM — Supabase client (workspace compartido)
// =====================================================================
// Credenciales del proyecto Supabase del workspace.
// La `anon key` está pensada para vivir en el frontend (es pública por
// diseño). La seguridad real la da la llave de acceso del frontend +
// las políticas RLS en la base de datos.
// =====================================================================

const FALLBACK_URL = 'https://usxqzztqgzrfpopvfmfc.supabase.co'
const FALLBACK_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVzeHF6enRxZ3pyZnBvcHZmbWZjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg4MzU3NjcsImV4cCI6MjA5NDQxMTc2N30._t1u-YXERewY0L2NP17xap2RGMCJZ4cMTaF591WAO_U'

const ENV_URL = (import.meta as any).env?.VITE_SUPABASE_URL as
  | string
  | undefined
const ENV_ANON_KEY = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY as
  | string
  | undefined

export const SUPABASE_URL = ENV_URL || FALLBACK_URL
export const SUPABASE_ANON_KEY = ENV_ANON_KEY || FALLBACK_ANON_KEY

export const isSupabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY)

export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
      },
      realtime: {
        params: { eventsPerSecond: 5 },
      },
    })
  : null

if (typeof window !== 'undefined') {
  if (isSupabaseConfigured) {
    // eslint-disable-next-line no-console
    console.info('[Growthly] Supabase conectado:', SUPABASE_URL)
  } else {
    // eslint-disable-next-line no-console
    console.warn(
      '[Growthly] Supabase NO configurado — modo local (localStorage).',
    )
  }
}
